import React from "react";
import { Link } from "react-router-dom";
const currentDomain = process.env.REACT_APP_SUB_DOMAIN;
const SiteBreadcrumb = (props) => {
  const { innerClass, parentCategory, pageCategory, pageName } = props;

  return (
    <div className="breadcrumb-bg">
      <div className="container-fluid">
        <div
          className={innerClass ? innerClass : "breadcrumbs-text white-color"}
        >
          <ul>
            <li>
              <Link to={`/${currentDomain}/`} className="active">
                {parentCategory ? parentCategory : "Home"}
              </Link>
            </li>
            {pageCategory && (
              <>
                <li>
                  <Link to={`/${pageCategory}`} className="active">
                    {pageCategory ? pageCategory : "Category"}
                  </Link>
                </li>
                <li>{pageName ? pageName : "Page Name"}</li>
              </>
            )}
            {!pageCategory && <li>{pageName ? pageName : "Page Name"}</li>}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SiteBreadcrumb;
